export default {
    isLogin({ profile = {} }) {
        return Object.keys(profile).length !== 0
    }
}